import { Button } from "@/components/shadcn/button";
import { formatDistance } from "date-fns";
import { az, tr } from "date-fns/locale";
import { Link } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";
import { isWebinarLinkTimeWindowActive } from "../../_actions/webinar/utils/is-webinar-link-time-window-active";
import { WebinarEventWithUserStatus } from "./types";

export default function EventLinkButton({
    event,
}: {
    event: WebinarEventWithUserStatus;
}) {
    const t = useTranslations("events");
    const locale = useLocale();

    if (event.status === "ended") {
        return null;
    }

    if (!event.isUserJoined) {
        return (
            <p className="text-center text-xs text-neutral-500">
                {t("joinToSeeLink")}
            </p>
        );
    }

    const isLinkAvailable = isWebinarLinkTimeWindowActive(event);
    if (isLinkAvailable) {
        if (event.meetingLink) {
            return (
                <a
                    href={event.meetingLink}
                    target="_blank"
                    className="flex items-center justify-center gap-2 text-sm text-neutral-900"
                >
                    <Button>
                        <Link size={12} />
                        <span>{t("join")}</span>
                    </Button>
                </a>
            );
        }

        return <span>{t("linkNotFound")}</span>;
    }

    return (
        <p className="text-center text-xs text-neutral-500">
            {event.linkActiveDate ? (
                <>
                    {t("linkActivePrefix")}{" "}
                    {formatDistance(
                        new Date(event.linkActiveDate),
                        new Date(event.date),
                        { locale: locale === "az" ? az : tr },
                    )}{" "}
                    {t("linkActiveSuffix")}
                </>
            ) : (
                t("linkActiveDefault")
            )}
        </p>
    );
}
